import NProgress from 'nprogress'
import React, { Fragment, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { connect, useSelector } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import AuthLayout from './Auth'
import MainLayout from './Main'
// import Loader from 'components/cleanui/layout/Loader'
import PublicLayout from './Public'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
}

const mapStateToProps = ({ user }) => ({ user })
let previousPath = ''

const Layout = ({ user, children, location: { pathname, search } }) => {
  // NProgress & ScrollTop Management
  const currentPath = pathname + search
  if (currentPath !== previousPath) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  setTimeout(() => {
    NProgress.done()
    previousPath = currentPath
  }, 300)

  // Layout Rendering
  const getLayout = () => {
    if (pathname === '/') {
      return 'public'
    }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return 'auth'
    }
    return 'main'
  }

  const Container = Layouts[getLayout()]
  const isUserAuthorized = user.authorized
  const isUserLoading = user.loading
  const isAuthLayout = getLayout() === 'auth'

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
      return null
    }
    // redirect to login page if current is not login page and user not authorized
    if (!isAuthLayout && !isUserAuthorized) {
      return <Redirect to="/auth/login" />
    }
    // in other case render previously set layout
    return <Container>{children}</Container>
  }
  const businessName = useSelector(state => state.user.businessName)
  const [title, setTitle] = useState(`${businessName} | %s`)
  const [notifyOrders, setNotifyOrders] = useState(null)
  const orders = useSelector(state => state.orders.data)
  useEffect(() => {
    orders && setNotifyOrders(orders.filter(order => order.orderType !== 'open'))
  }, [orders])

  useEffect(() => {
    if (notifyOrders && notifyOrders.length > 0) {
      // setInterval(() => {
      console.log(
        '🚀 ~ file: index.js ~ line 72 ~ useEffect ~ notifyOrders.length > 0',
        notifyOrders.length > 0,
      )
      // if (sec % 2 === 0) {
      setTitle(() => `Order Come `)
      // } else {
      //   setTitle(() => `${businessName} | %s`)
      // }
      // }, 1000)
    } else {
      setTitle(() => (businessName ? `${businessName} | %s` : 'Quick Menu | %s'))
    }
  }, [notifyOrders])

  return (
    <Fragment>
      <Helmet titleTemplate={title} title="welcome" />
      {BootstrappedLayout()}
    </Fragment>
  )
}

export default withRouter(connect(mapStateToProps)(Layout))
